import { css, cx } from '@emotion/css';
import { Button } from '@repo/ui/molecules';

import { getHasPaddingEnabled } from '@repo/logic';
import { useState } from 'react';
import QuestionTitle from '../common/QuestionTitle';
import { useStudyContext } from '../utils/StudyContext';
import { useTranslationsContext } from '../utils/TranslationsContext';
import Description from './common/Description';
import { QuestionWrapperStyle } from './stepsStyle';
import type { MultipleChoiceStepT, StatementStepT, StepT } from './types';

type Props = {
    step: MultipleChoiceStepT | StatementStepT;
    answerStep: (v: StepT) => Promise<void>;
};

const MultipleChoiceStep = ({ step, answerStep }: Props) => {
    const { study } = useStudyContext();
    const [loadingIndex, setLoadingIndex] = useState<number | undefined>();
    const { t } = useTranslationsContext();
    const sortedArray = step.options.sort((a, b) => a.position - b.position);

    function onSubmit(index: number) {
        setLoadingIndex(index);
        answerStep({
            ...step,
            answer: sortedArray[index],
        }).finally(() => {
            setLoadingIndex(undefined);
        });
    }

    return (
        <div className={QuestionWrapperStyle}>
            <div className={'uxsignals-header'}>
                <QuestionTitle label={step.label} />
            </div>
            <Description text={step.description} />
            <div
                className={cx(
                    ButtonGroupStyle(
                        getHasPaddingEnabled(study.orgId) ? 32 : 0,
                    ),
                    'uxsignals-cta-container',
                )}
            >
                {sortedArray.map((option, index) => (
                    <Button
                        loadingLabel={t('common.loading')}
                        className="uxsignals-cta"
                        variant="tertiary"
                        key={step.id + step.label + option.label + index}
                        isLoading={loadingIndex === index}
                        disabled={typeof loadingIndex === 'number'}
                        ariaLabel={`${option.label}`}
                        onClick={() => {
                            onSubmit(index);
                        }}
                        children={option.label}
                    />
                ))}
            </div>
        </div>
    );
};
export default MultipleChoiceStep;

const ButtonGroupStyle = (margin: number) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: ${margin}px;
`;
